import React from 'react';
import { Field, EditView } from '@builtbypixel/nucleus';

import setup from './setup';
import {Container} from "@chakra-ui/react";

const EditForm = () => {
  return (
    <EditView setup={setup} isFullWidth={false}>
      <Container
          p={{ base: '10px', sm: '15px' }}
          w='100%'
          variant='card'
          rounded='none'
          maxWidth='none'
      >
          <Field auto isFullWidth name="name" component="text" label="Name" />
          <Field auto isFullWidth name="summary" component="richtext" label="Summary" />
          <Field auto isFullWidth name="description" component="richtext" label="Description" />
          <Field auto isFullWidth name="banner_image" component="file" label="Banner Image" />
          <Field auto isFullWidth name="show_on_nav" component="switch" label="Deal Type" />
      </Container>
    </EditView>
  );
};

export default EditForm;
